export enum StorageKeys {
    Lang = 'agent.lang',
    Access = 'agent.access',
    TermCode = 'agent.termCode',
}
